import React, { useState, useEffect, useContext } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Badge from "@material-ui/core/Badge";
// import NotificationsIcon from "@material-ui/icons/Notifications";
import NotificationsIcon from "../../assets/navbarIcons/notificationsIcon";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { BiSupport } from "react-icons/bi";
import { useMutation, useQuery, useQueryClient } from "react-query";

import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL } from "../../services/configs";

import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";
import CENTRIFUGE_OBJ from "../../services/centrifuge";
import CloseIconNoti from "../../assets/icons/closeiconnoti";

export default function NotificationDropDown() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const queryClient = useQueryClient();

  const token = useSelector((state) => state.trading.TOKEN);
  const loginId = useSelector((state) => state.trading.LOGIN_ID);

  const [notifs, setNotifs] = useState(null);
  const [refresh, setRefresh] = useState(null);

  const {
    updateOrders,
    refreshOrders,
    handleClickAlert,
    kycData,
    updateBalances,
  } = useContext(CoinContext);

  //for handling the popover when clicked notifications icon
  const [anchorNoti, setAnchorNoti] = useState(null);

  const handleClickNoti = (event) => {
    setAnchorNoti(event.currentTarget);
  };

  const handleCloseNoti = () => {
    setAnchorNoti(null);
  };

  const openNoti = Boolean(anchorNoti);
  const idNoti = openNoti ? "simple-popover-noti" : undefined;

  useEffect(() => {
    getNotifications();
  }, [refresh, refreshOrders]);

  useEffect(() => {
    if (loginId) {
      // if loginId is a phone number
      if (/^\d+$/.test(loginId)) {
        if (kycData.email) {
          // console.log("email from kyc", kycData.email);
          var channelp = CENTRIFUGE_OBJ.centrifuge.subscribe(
            `web-notifications-${kycData.email}${CENTRIFUGE_OBJ.env}`,
            ({ data }) => {
              console.log("web-notifications", data);
              handleClickAlert("success", data.notificationMessage);
              // getNotifications()
              updateOrders(data.id);
              updateBalances(data.id);
              queryClient.refetchQueries(["bankAccount"]);
            }
          );
        }
      } else {
        CENTRIFUGE_OBJ.centrifuge.subscribe(
          `web-notifications-${loginId}${CENTRIFUGE_OBJ.env}`,
          ({ data }) => {
            console.log("web-notifications", data);
            handleClickAlert("success", data.notificationMessage);
            updateOrders(data.id);
            updateBalances(data.id);
            queryClient.refetchQueries(["bankAccount"]);
          }
        );
      }
    }
  }, [kycData]);

  function getNotifications() {
    if (token) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/notifications`)
        .then((data) => {
          if (data.notifications) {
            setNotifs(data);
          }
          // console.log("Notifications", data);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });

      // console.log("Getting notifications");
    }
  }

  function clickNotification(nId, unread) {
    // console.log(nId);
    // console.log("unread", unread);

    if (unread) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/markAsRead?notificationId=${nId}`, { method: "POST" })
        .then((res) => {
          setRefresh(nId);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });

      // console.log("Marking as read");
    }
    handleCloseNoti();
  }

  function markAllRead() {
    if (token && notifs.unReadNotifications !== 0) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/markAllAsRead`, { method: "POST" })
        .then((res) => {
          setRefresh(true);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });

      // console.log("Marking all notifications as read");
    }
    handleCloseNoti();
  }

  return (
    <>
      <IconButton
        aria-describedby={idNoti}
        onClick={handleClickNoti}
        style={{ padding: "0px", marginRight: "0px" }}
      >
        <Badge
          badgeContent={notifs ? notifs.unReadNotifications : null}
          max={99}
          color="primary"
        >
          <NotificationsIcon fill={openNoti ? "#3AC4AB" : "#B9BABF"} />
        </Badge>
      </IconButton>

      {/* anchorReference="anchorPosition"
      anchorPosition={{ top: 65, left: 1560 }} */}

      <Popover
        id={idNoti}
        open={openNoti}
        anchorEl={anchorNoti}
        onClose={handleCloseNoti}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className={`${classes.typography} relative`}>
          <Button
            onClick={handleCloseNoti}
            disableRipple
            className="w-[10px] hover:bg-transparent top-3 h-[10px] absolute  right-[-6%] p-0"
          >
            <CloseIconNoti />
          </Button>
          {notifs ? (
            notifs.notifications ? (
              notifs.notifications.totalElements === 0 ? (
                <p style={{ textAlign: "center" }}>You have no notifications</p>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      paddingLeft: "14px",
                      paddingRight: "14px",
                      paddingTop: "10px",
                      alignItems: "center",
                      marginTop: "10px",
                    }}
                  >
                    <p style={{ fontWeight: "bold", fontSize: "15px" }}>
                      {notifs.unReadNotifications} unread notifications
                    </p>
                    <div className={classes.grow} />
                    {notifs.unReadNotifications !== 0 ? (
                      <p
                        style={{ marginRight: "10px" }}
                        className={classes.link}
                        onClick={markAllRead}
                      >
                        Mark all as read
                      </p>
                    ) : null}
                    <p
                      className={classes.link}
                      onClick={() => {
                        history.push(`/allnotifications`);
                        handleCloseNoti();
                      }}
                    >
                      View All
                    </p>
                  </div>

                  {/* style={{
                          background: noti.isActive ? null : "#F6F6F6",
                          pointerEvents: noti.isActive ? null : "none",
                          opacity: noti.isActive ? null : "0.6",
                        }} */}

                  <List>
                    {notifs.notifications.content.map((noti) => {
                      return noti.isActive ? (
                        <ListItem
                          button
                          onClick={() =>
                            clickNotification(noti.id, noti.isActive)
                          }
                        >
                          <ListItemText
                            secondary={`${
                              noti.notificationMessage
                            } at ${noti.createdAt.slice(
                              8,
                              10
                            )}.${noti.createdAt.slice(
                              5,
                              7
                            )}.${noti.createdAt.slice(
                              0,
                              4
                            )} ${noti.createdAt.slice(11, 16)}`}
                          >
                            {noti.title}
                          </ListItemText>
                          <div className={classes.grow} />
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <FiberManualRecordIcon htmlColor="green" />
                          </ListItemIcon>
                        </ListItem>
                      ) : null;
                    })}
                  </List>
                </>
              )
            ) : (
              <p style={{ textAlign: "center" }}>Loading...</p>
            )
          ) : (
            <p style={{ textAlign: "center" }}>Loading...</p>
          )}
        </div>
      </Popover>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(1),
    background: theme.palette.type === "dark" ? "#151828" : "white",
    maxWidth: "460px",
    // minWidth: "340px",
    maxHeight: "300px",
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    paddingLeft: "10px",
    "&:hover": {
      fontWeight: "bold",
      color: theme.palette.primary.main,
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
}));
